<template>
  <div>
    <div
      v-for="(room, index) in stayRooms"
      :key="`relationship-room-${index}`"
      v-show="room.relationships && room.relationships.filter((r) => r.isMember).length"
    >
      <div class="w-full pt-2 pb-4">
        <div>
          <table
            class="coupon-rel-table table-common lg:hidden"
            v-show="room.relationships.filter((r) => !r.isVisitor).length"
          >
            <thead>
              <tr>
                <td class="coupon-rel-table-col-1">{{ room.roomNo }}部屋目</td>
                <td class="coupon-rel-table-col-2">会員との続柄</td>
                <td class="coupon-rel-table-col-3" v-show="childMemberCnt(room) > 0">
                  <span>年齢</span>
                </td>
                <td v-if="showRelationName" class="coupon-rel-table-col-4 lg:hidden">
                  <div class="flex justify-between items-center">
                    <span>
                      姓<span class="small-text">（漢字・かな・半角英字）</span>
                    </span>
                    <span class="category">必須</span>
                  </div>
                </td>
                <td v-if="showRelationName" class="coupon-rel-table-col-5 lg:hidden">
                  <div class="flex justify-between items-center">
                    <span>名<span class="small-text">（漢字・かな・半角英字）</span></span>
                    <span class="category">必須</span>
                  </div>
                </td>
                <!-- <td>&nbsp;</td> -->
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, idx) in room.relationships.filter((r) => !r.isVisitor)" :key="`people-relation-${idx}`">
                <td>{{ item.label }}</td>
                <td class="px-1">
                  <a-select
                    placeholder="続柄"
                    class="coupon-rel-table-col-2"
                    v-model="item.relationshipCode"
                    @change="onChangeRelationship(index, idx)"
                  >
                    <a-select-option
                      :value="el.value"
                      v-for="(el, index) in relationshipOptions"
                      :key="`rela-${index}`"
                    >
                      {{ el.label }}
                    </a-select-option>
                  </a-select>
                </td>
                <td class="p-0 coupon-rel-table-col-3" v-show="childMemberCnt(room) > 0">
                  <a-input 
                    v-model="item.age"
                    :maxLength="2"
                    @keypress="validateNumber($event)"
                    @change="onChangeRelationInput"
                    :disabled="!item.isChildren"
                    class="px-4 text-center"
                    :class="[item.isChildren ? '' : 'hidden']"
                    @blur="checkChildAge(item.age)"
                  />
                  <div v-show="!item.isChildren">
                    <svg viewBox='0 0 110 43' preserveAspectRatio='none' width="110px" height="43px">
                      <line x1="0" y1="43" x2="110" y2="0" vector-effect="non-scaling-stroke" stroke="#cacccf" />
                    </svg>
                  </div>
                </td>
                <td v-if="showRelationName" class="lg:hidden">
                  <a-input
                    type="text"
                    v-model="item.familyName"
                    @change="checkSei(room.relationships[idx])"
                    placeholder="べねふぃっと"
                  />
                </td>
                <td v-if="showRelationName" class="lg:hidden">
                  <a-input
                    type="text"
                    v-model="item.firstName"
                    @change="checkMei(room.relationships[idx])"
                    placeholder="はなこ"
                  />
                </td>
              </tr>
              
            </tbody>
          </table>

          <div class="hidden coupon-rel-sp lg:block">
            <div class="header">
              {{ room.roomNo }}部屋目
            </div>
            <div v-for="(item, idx) in room.relationships.filter((r) => !r.isVisitor)">
              <a-divider class="input-divider" v-if="idx > 0"></a-divider>
              <div class="member">
                  {{ item.label }}
              </div>
              
              <div class="px-4">
                <div class="flex flex-row mb-2">
                  <div class="flex flex-col flex-1">
                    <label class="text-xs2 mb-2">会員との続柄</label>
                    <a-select
                      placeholder="会員との続柄"
                      size="large"
                      v-model="item.relationshipCode"
                      @change="onChangeRelationship(index, idx)"
                    >
                      <a-select-option
                        :value="el.value"
                        v-for="(el, index) in relationshipOptions"
                        :key="`rela-${index}`"
                      >
                        {{ el.label }}
                      </a-select-option>
                    </a-select>
                  </div>
                  <div class="flex flex-col ml-3.5 age-input-wrapper" v-show="childMemberCnt(room) > 0">
                    <label class="text-xs2 mb-2">年齢</label>
                    <a-input 
                      v-model="item.age"
                      :maxLength="2"
                      @keypress="validateNumber($event)"
                      @change="onChangeRelationInput"
                      :disabled="!item.isChildren"
                      class="px-4 text-center"
                      :class="[item.isChildren ? '' : 'hidden']"
                      @blur="checkChildAge(item.age)"
                    />
                    <div v-show="!item.isChildren" class="no-child">
                      <svg viewBox='0 0 73 37' preserveAspectRatio='none' width="73px" height="37px">
                        <line x1="0" y1="37" x2="73" y2="0" vector-effect="non-scaling-stroke" stroke="#cacccf" />
                      </svg>
                    </div>
                  </div>
                </div>
                <div class="flex flex-col mt-2" v-if="showRelationName">
                  <label class="text-xs">姓<span class="small-text">（漢字・かな・半角英字）</span><span class="category whitespace-nowrap">必須</span></label>
                  <a-input type="text"
                  class="w-full mr-2 mt-2"
                  v-model="item.familyName"
                  @change="checkSei(room.relationships[idx])"
                  placeholder="べねふぃっと" />
                </div>
                <div class="flex flex-col mt-2" v-if="showRelationName">
                  <div class="text-xs">名<span class="small-text">（漢字・かな・半角英字）</span><span class="category whitespace-nowrap">必須</span></div>
                  <a-input
                    type="text"
                    class="w-full mt-2"
                    v-model="item.firstName"
                    @change="checkMei(room.relationships[idx])"
                    placeholder="はなこ"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { get, cloneDeep } from 'lodash'
import func_utils from '@/mixins/func_utils'
import plan_utils from '@/mixins/plan_utils'
import { RELATIONSHIP_AVAILABLES } from '@/constants/customer'

export default {
  name: 'PeopleRelationship',
  props: ['visible', 'stayRoomDetails', 'isReRenderListRoom', 'showRelationName', 'publicStay'],
  mixins: [func_utils, plan_utils],
  data() {
    return {
      stayRooms: [],
      maxStayCapacity: null,
      childrenCount: 0,
      hasError: false,
      getRelationship: null,
      error_message_age: ''
    }
  },
  created() {},
  mounted() {
    // if (this.stayRoomDetails) {
    //   let stayRoomDetails = cloneDeep(this.stayRoomDetails)
    //   stayRoomDetails = stayRoomDetails.map(room => {
    //     // eslint-disable-next-line no-undef
    //     room.relationships = this.renderRelationshipList(room)
    //     return room
    //   })
    //   this.stayRooms = stayRoomDetails
    // }
    this.getRelationship = cloneDeep(
      get(this.$store.getters.bs_app, 'check_relationship', null)
    )
    this.loadScreenData()
    this.setLimitRoomCapacity()
  },
  computed: {
    planDetail() {
      return cloneDeep(get(this.$store.state, 'plan.planDetail', null))
    },
    customerPlan() {
      return cloneDeep(this.$store.getters.customerPlan)
    },
    bsAppState() {
      return this.$store.getters.bs_app
    },
    peopleOptions() {
      const peoples = [
        {
          label: 0,
          value: 0
        }
      ]
      const maxAdultPeople =
        (this.maxStayCapacity ? this.maxStayCapacity : 99) * this.limitRooms
      for (let i = 0; i < maxAdultPeople; i++) {
        peoples.push({
          label: i + 1,
          value: i + 1
        })
      }
      return peoples
    },
    relationshipMasterData() {
      const subsidyList = this.customerPlan.subsidyList
      let relationshipPds = null
      // 続柄Cdが50(2親等用)以外が返却された場合、該当のデータを使用
      relationshipPds = subsidyList
        .filter((item) => get(item, 'scrennDisplayItemList.relationshipPd.relationshipPatternCd') !== '50')
        .filter((item) => 
            Array.isArray(get(item, 'scrennDisplayItemList.relationshipPd.valueList')) && 
            get(item, 'scrennDisplayItemList.relationshipPd.valueList').length > 0
        )
      // 続柄Cdが50(2親等用)以外がない場合(続柄Cdが50(2親等用)1種類が帰ってきた場合)
      // 続柄Cdが50のデータを使用
      if (relationshipPds.length === 0) {
        relationshipPds = subsidyList
        .filter((item) => get(item, 'scrennDisplayItemList.relationshipPd.relationshipPatternCd') === '50')
        .filter((item) => 
            Array.isArray(get(item, 'scrennDisplayItemList.relationshipPd.valueList')) && 
            get(item, 'scrennDisplayItemList.relationshipPd.valueList').length > 0
        )
      }
      if(relationshipPds) {
        return this.getValueListRelationShip(relationshipPds)
      }
      return null
    },
    relationshipOptions() {
      return this.relationshipMasterData.map((e) => ({
        label: e.relationshipName,
        value: `${e.code}-${e.relationshipId}-${e.relationshipLevel}`
      }))
    },
  },
  methods: {
    getValueListRelationShip(relationshipPds) {
      if (relationshipPds) {
        let valueList = get(relationshipPds[0], 'scrennDisplayItemList.relationshipPd.valueList')
        return valueList.map((val) => {
          const splited = val.split('|')
          return {
            code: 'C',
            groupName: null,
            relationshipId: splited[1],
            relationshipName: splited[0],
            relationshipLevel: splited[2],
            genderDistinction: null
          }
        })
      }
      return RELATIONSHIP_AVAILABLES.filter((s) => +s.code === 50)
    },
    checkChildAge() {
      let inputAge = true
      let formatIncorrect = false
      if (this.stayRooms && Array.isArray(this.stayRooms)) {
        this.stayRooms.forEach((item) => {
          item.relationships.forEach((i) => {
            if ((i.age > 12 || i.age < 0 || !i.age) && i.isChildren) {
              inputAge = false
            }
            if (i.isChildren) {
              if (!this.validateAgeChild(i.age)) {
                formatIncorrect = true
              }
            }
          })
        })
      }
      if (inputAge) {
        this.error_message_age = ''
        if (formatIncorrect) {
          this.error_message_age = '半角の数字を入力してください。'
        }
      } else {
        this.error_message_age = '会員子どもの年齢は12歳以下を入力してください。'
      }
      this.$emit('messageErrorAge', this.error_message_age)
    },
    checkSei(relationship) {
      relationship.familyName = this.onReplaceKanjiHiraRomaji(relationship.familyName)

      let inputSei = true
      if (this.stayRooms && Array.isArray(this.stayRooms)) {
        this.stayRooms.forEach((item) => {
          item.relationships.forEach((i) => {
            if (this.showRelationName && !i.familyName) {
              inputSei = false
            }
          })
        })
      }
      if (inputSei) {
        this.$emit('messageErrorSei', "")
      }
      this.onChangeRelationInput
    },
    checkMei(relationship) {
      relationship.firstName = this.onReplaceKanjiHiraRomaji(relationship.firstName)

      let inputMei = true
      if (this.stayRooms && Array.isArray(this.stayRooms)) {
        this.stayRooms.forEach((item) => {
          item.relationships.forEach((i) => {
            if (this.showRelationName && !i.firstName) {
              inputMei = false
            }
          })
        })
      }
      if (inputMei) {
        this.$emit('messageErrorMei', "")
      }
      this.onChangeRelationInput
    },
    loadScreenData() {
      if (this.visible === true) {
        let stayRoomDetails = cloneDeep(this.stayRoomDetails)
        stayRoomDetails = stayRoomDetails.map((room) => {
          const memberCnt = room.member.man + room.member.woman
          // const visitorCnt = room.visitors.man + room.visitors.woman
          const memberChldCnt = Object.keys(room.memberChildren)
            .map((key) => room.memberChildren[key])
            .reduce((a, b) => a + b, 0)
          // const visitorChldCnt = Object.keys(room.visitorChildren).map(key => room.visitorChildren[key]).reduce((a, b) => a + b, 0)
          const totalPeopleCnt = memberCnt + memberChldCnt
          // eslint-disable-next-line no-undef
          if (
            !room.relationships ||
            room.relationships.length !== totalPeopleCnt ||
            this.isReRenderListRoom
          ) {
            room.relationships = this.renderRelationshipList(room)
          }
          return room
        })
        this.stayRooms = stayRoomDetails
      } else {
        this.error_message_age = ''
      }
    },
    checkRelationship(relationshipCode) {
      let count = 0
      this.stayRooms.forEach((item) => {
        item.relationships.forEach((i) => {
          if (i.relationshipCode === relationshipCode) {
            count++
          }
        })
      })
      return count > 1
    },
    setLimitRoomCapacity() {
      if (get(this.planDetail, 'menuInformation.extSystemCd') === 'RakutenT') {
        this.limitRooms = 10
      } else if (get(this.planDetail, 'menuInformation.extSystemCd') === 'ToyokoInn') {
        this.limitRooms = 4
      } else {
        this.limitRooms = 19
      }
      this.limitPeoples = 19
    },
    renderRelationshipList(room) {
      // room.member.man + room.member.woman,
      // room.visitors.man + room.visitors.woman,
      // room.memberChildren,
      // room.visitorChildren
      // memberAdults, visitorAdults, memberChldDetails, visitorChldDetails
      // const memberAdults = room.member.man + room.member.woman || 0
      // const visitorAdults = room.visitors.man + room.visitors.woman || 0
      const memberChldDetails = room.memberChildren
      // const visitorChldDetails = room.visitorChildren
      let peopleCnt = 0
      let adultCnt = 0
      const arr = []
      let memberManCnt = 0
      const manLabel = this.publicStay ? '' : '男性';
      for (let i = 0; i < room.member.man; i++) {
        peopleCnt += 1
        memberManCnt += 1
        adultCnt += 1
        arr.push({
          id: peopleCnt,
          label: `会員${manLabel} ${memberManCnt}`,
          value: `会員${manLabel} ${memberManCnt}`,
          relationshipCode: null,
          relationship: null,
          age: null,
          isMember: true,
          isChildren: false,
          isVisitor: false
        })
      }

      let memberWomanCnt = 0
      for (let i = 0; i < room.member.woman; i++) {
        peopleCnt += 1
        memberWomanCnt += 1
        adultCnt += 1
        arr.push({
          id: peopleCnt,
          label: `会員女性 ${memberWomanCnt}`,
          value: `会員女性 ${memberWomanCnt}`,
          relationshipCode: null,
          relationship: null,
          age: null,
          firstName: null,
          familyName: null,
          isMember: true,
          isChildren: false,
          isVisitor: false
        })
      }

      // for (let i = 0; i < visitorAdults; i++) {
      //   peopleCnt += 1
      //   adultCnt += 1
      //   arr.push({
      //     id: peopleCnt,
      //     label: `大人 ${adultCnt}`,
      //     value: `大人 ${adultCnt}`,
      //     relationshipCode: null,
      //     relationship: null,
      //     age: null,
      //     isMember: false,
      //     isChildren: false,
      //     isVisitor: true
      //   })
      // }

      let memberChildrenCnt = 0
      Object.keys(memberChldDetails).forEach((key) => {
        if (memberChldDetails[key]) {
          for (let i = 0; i < memberChldDetails[key]; i++) {
            peopleCnt += 1
            memberChildrenCnt += 1
            arr.push({
              id: peopleCnt,
              label: `会員子ども ${memberChildrenCnt}`,
              value: `会員子ども ${memberChildrenCnt}`,
              relationshipCode: null,
              relationship: null,
              age: null,
              firstName: null,
              familyName: null,
              isMember: true,
              isChildren: true,
              chldType: key,
              isVisitor: false
            })
          }
        }
      })

      // Object.keys(visitorChldDetails).forEach(key => {
      //   if (visitorChldDetails[key]) {
      //     for(let i = 0; i < visitorChldDetails[key]; i++) {
      //       peopleCnt += 1
      //       arr.push({
      //         id: peopleCnt,
      //         label: `子ども ${peopleCnt - adultCnt}`,
      //         value: `子ども ${peopleCnt - adultCnt}`,
      //         relationshipCode: null,
      //         relationship: null,
      //         age: null,
      //         isMember: false,
      //         isChildren: true,
      //         chldType: key,
      //         isVisitor: true
      //       })
      //     }
      //   }
      // })
      this.$emit('adultCnt', adultCnt + memberChildrenCnt)
      return arr
    },
    onChangeRelationship(roomIndex, idx) {
      const selectedRelCode = this.stayRooms[roomIndex].relationships[idx].relationshipCode
      const selectedRelSplitCode = selectedRelCode.split('-').map((e) => String(e).trim())
      const arr = this.relationshipMasterData.filter(
        (e) =>
          e.code === selectedRelSplitCode[0] &&
          e.relationshipId === selectedRelSplitCode[1] &&
          e.relationshipLevel === selectedRelSplitCode[2]
      )
      if (arr.length) {
        this.stayRooms[roomIndex].relationships[idx].relationship = arr[0]
      }
      this.hasError = this.checkRelationship(selectedRelCode)
      if (this.hasError) {
        this.$nextTick(() => {
          this.stayRooms[roomIndex].relationships[idx].relationshipCode = null
          this.$toasted.error(`${arr[0].relationshipName}は1回のみ選択できます。`)
        })
      }
      this.$emit('input', this.stayRooms)
    },
    onChangeRelationInput() {
      this.$emit('input', this.stayRooms)
    },
    childMemberCnt(room) {
      return Object.keys(room.memberChildren)
        .map((key) => room.memberChildren[key])
        .reduce((a, b) => a + b, 0)
    }
  },
  watch: {
    visible() {
      this.loadScreenData()
    },
    stayRoomDetails: {
      handler() {
        this.loadScreenData()
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
@import './style.scss';

.coupon-rel-table-col {
  &-4,
  &-5 {
    white-space: nowrap;
  }
}
</style>
